import LoginForm from "../../components/Login/LoginForm";
import "./Home.scss";

const Home = () => {
  return (
    <div className="Home">
      <LoginForm />
    </div>
  );
};

export default Home;
